import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageAdsList,
  PageAd,
} from '../pages/ads';

const RouteAds = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageAdsList />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageAd />
      </Route>
    </Switch>
  );
};

export default RouteAds;
